// tools/blender/glyphs.py tarafından üretilir — elle düzenleme
export default {
    "cap": 0.8,
    "depth": 0.32,
    "gap": 0.12,
    "space": 0.42,
    "chars": {
        "A": {
            "code": "0041",
            "width": 0.6999,
            "height": 0.8
        },
        "B": {
            "code": "0042",
            "width": 0.6649,
            "height": 0.8
        },
        "C": {
            "code": "0043",
            "width": 0.6387,
            "height": 0.8306
        },
        "D": {
            "code": "0044",
            "width": 0.6649,
            "height": 0.8
        },
        "E": {
            "code": "0045",
            "width": 0.5341,
            "height": 0.8
        },
        "F": {
            "code": "0046",
            "width": 0.5167,
            "height": 0.8
        },
        "G": {
            "code": "0047",
            "width": 0.6387,
            "height": 0.8305
        },
        "H": {
            "code": "0048",
            "width": 0.6082,
            "height": 0.8
        },
        "I": {
            "code": "0049",
            "width": 0.1811,
            "height": 0.8
        },
        "J": {
            "code": "004A",
            "width": 0.6213,
            "height": 0.8153
        },
        "K": {
            "code": "004B",
            "width": 0.6648,
            "height": 0.8
        },
        "L": {
            "code": "004C",
            "width": 0.5298,
            "height": 0.8
        },
        "M": {
            "code": "004D",
            "width": 0.8545,
            "height": 0.8
        },
        "N": {
            "code": "004E",
            "width": 0.6235,
            "height": 0.8
        },
        "O": {
            "code": "004F",
            "width": 0.6649,
            "height": 0.8306
        },
        "P": {
            "code": "0050",
            "width": 0.5952,
            "height": 0.8
        },
        "Q": {
            "code": "0051",
            "width": 0.6649,
            "height": 1.0114
        },
        "R": {
            "code": "0052",
            "width": 0.6061,
            "height": 0.8
        },
        "S": {
            "code": "0053",
            "width": 0.6257,
            "height": 0.8305
        },
        "T": {
            "code": "0054",
            "width": 0.6257,
            "height": 0.8
        },
        "U": {
            "code": "0055",
            "width": 0.6344,
            "height": 0.8153
        },
        "V": {
            "code": "0056",
            "width": 0.6821,
            "height": 0.8
        },
        "W": {
            "code": "0057",
            "width": 0.9556,
            "height": 0.8
        },
        "X": {
            "code": "0058",
            "width": 0.7185,
            "height": 0.8
        },
        "Y": {
            "code": "0059",
            "width": 0.7238,
            "height": 0.8
        },
        "Z": {
            "code": "005A",
            "width": 0.5668,
            "height": 0.8
        },
        "Ç": {
            "code": "00C7",
            "width": 0.6387,
            "height": 1.0485
        },
        "Ğ": {
            "code": "011E",
            "width": 0.6387,
            "height": 1.0201
        },
        "İ": {
            "code": "0130",
            "width": 0.2139,
            "height": 1.0332
        },
        "Ö": {
            "code": "00D6",
            "width": 0.6649,
            "height": 1.0485
        },
        "Ş": {
            "code": "015E",
            "width": 0.6257,
            "height": 1.0484
        },
        "Ü": {
            "code": "00DC",
            "width": 0.6344,
            "height": 1.0485
        },
        "0": {
            "code": "0030",
            "width": 0.6344,
            "height": 0.8306
        },
        "1": {
            "code": "0031",
            "width": 0.4551,
            "height": 0.8
        },
        "2": {
            "code": "0032",
            "width": 0.5973,
            "height": 0.8153
        },
        "3": {
            "code": "0033",
            "width": 0.6191,
            "height": 0.8153
        },
        "4": {
            "code": "0034",
            "width": 0.678,
            "height": 0.8
        },
        "5": {
            "code": "0035",
            "width": 0.6126,
            "height": 0.8153
        },
        "6": {
            "code": "0036",
            "width": 0.6126,
            "height": 0.8305
        },
        "7": {
            "code": "0037",
            "width": 0.5864,
            "height": 0.8
        },
        "8": {
            "code": "0038",
            "width": 0.63,
            "height": 0.8305
        },
        "9": {
            "code": "0039",
            "width": 0.6126,
            "height": 0.8305
        },
        ".": {
            "code": "002E",
            "width": 0.2444,
            "height": 0.2444
        },
        "&": {
            "code": "0026",
            "width": 0.6355,
            "height": 0.8
        },
        "-": {
            "code": "002D",
            "width": 0.3598,
            "height": 0.1615
        }
    }
}
